/** KLineCharts always reads `styles.lines[].dashedValue[0]` — never omit or set undefined. */
export type KLineLineStyle = "solid" | "dashed" | "dotted";

export function lineStyleToKLine(style: string | undefined): KLineLineStyle {
  if (style === "dashed" || style === "dotted") return style;
  return "solid";
}

export function dashedValueForStyle(style: KLineLineStyle): [number, number] {
  return style === "dashed" ? [4, 4] : [2, 2];
}

export function klineLineStyle(
  color: string,
  size: number,
  style: KLineLineStyle
): {
  color: string;
  size: number;
  style: KLineLineStyle;
  dashedValue: [number, number];
} {
  return {
    color,
    size,
    style,
    dashedValue: dashedValueForStyle(style),
  };
}
